// material-ui
import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */
import playwatchlogo from 'assets/images/playwatch.svg';
import TitleService from 'title-service';

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    const theme = useTheme();

    return <>
        <img src={playwatchlogo} alt={TitleService('Playwatch')} width="100" />
        {/* <div style={{ position: 'relative' }}>
            <span style={{
                fontSize: 48,
                fontWeight: 'bold',
                position: 'absolute',
                color: 'white',
                transform: 'rotate(13deg)'
            }}>BETA</span>
        </div> */}
    </>

};

export default Logo;
